import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLocalStorageValue } from '@react-hookz/web';
import { T } from 'gt-react';
import {
  EntityDetailTabsProvider,
  EntityDetailTabsHeader,
  EntityDetailTabsContent,
  useEntityDetailTabsContext,
} from '@/components/system-entities/entity-detail-tabs';
import { SystemEntity } from '@erp/shared-types';
import { Tabs } from '@/components/ui/tabs';

function InvoiceDetailTabsWrapper() {
  const { activeTabId, setActiveTabId } = useEntityDetailTabsContext();
  return (
    <Tabs
      value={activeTabId}
      onValueChange={setActiveTabId}
      className="flex flex-col flex-1 min-h-0"
    >
      <SheetHeader className="shrink-0 grow-0">
        <EntityDetailTabsHeader />
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <EntityDetailTabsContent />
      </div>
    </Tabs>
  );
}

export function InvoiceDetailSlidein({
  isOpen,
  onOpenChange,
  invoiceId,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  invoiceId?: string;
}) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('invoice-detail-view-size', {
      defaultValue: 50,
    });

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        resizableProps={{
          defaultSize: detailViewSize,
          onResize: setDetailViewSize,
          className: 'flex flex-col',
        }}
      >
        {invoiceId ? (
          <EntityDetailTabsProvider
            initialEntity={{
              entityType: SystemEntity.AP_INVOICE,
              entityId: invoiceId,
            }}
          >
            <InvoiceDetailTabsWrapper />
          </EntityDetailTabsProvider>
        ) : (
          <>
            <SheetHeader className="shrink-0 grow-0">
              <SheetTitle>
                <T context="title for the invoice detail slide-in panel">
                  Invoice Details
                </T>
              </SheetTitle>
            </SheetHeader>
            <div className="p-4 text-sm text-muted-foreground">
              <T context="placeholder text shown when no invoice is selected in the invoice detail panel">
                No invoice selected
              </T>
            </div>
          </>
        )}
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            <T context="button label to close the invoice detail panel">
              Close
            </T>
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
